export default "__VITE_ASSET__BdbGP4nv__"